import { MapPoi, Poi, PoiCategory, PoiType } from '@/types/poi'

import { generateUuidRequestId } from './uuid-request-id'

export const isTransportType = (poiType: PoiType): boolean => {
  return poiTypes.TRANSPORT.types.includes(poiType)
}

export const sortedPointsOfInterestByDistance = (pois: Poi[]): MapPoi[] => {
  return pois.map((poi) => ({ ...poi, slug: generateUuidRequestId() })).sort((a, b) => a.distance - b.distance)
}

const nearbyPoiSchool = (pois: MapPoi[]): MapPoi => {
  return pois.find((poi) => poi.poiType === PoiType.School)
}

const nearbyPoiShop = (pois: MapPoi[]): MapPoi => {
  return pois.find((poi) => poi.poiType === PoiType.Shop)
}

const nearbyPoiTransport = (pois: MapPoi[], priorityType?: PoiType): MapPoi => {
  if (priorityType) {
    const nearbyPriorityPoi = pois.find((poi) => poi.poiType === priorityType)

    if (nearbyPriorityPoi) {
      return nearbyPriorityPoi
    }
  }

  return pois.find((poi) => isTransportType(poi.poiType as PoiType))
}

export const nearbyUniqueByTypePois = (pois: Poi[], transportPriorityType?: PoiType): MapPoi[] => {
  const sortedPois = sortedPointsOfInterestByDistance(pois)
  return [
    nearbyPoiTransport(sortedPois, transportPriorityType),
    nearbyPoiShop(sortedPois),
    nearbyPoiSchool(sortedPois),
  ].filter((poi) => poi)
}

export const poiTypes: Record<PoiCategory, Record<'types', PoiType[]>> = {
  SCHOOL: { types: [PoiType.School] },
  SHOP: { types: [PoiType.Shop] },
  TRANSPORT: { types: [PoiType.BusStop, PoiType.TrainStation, PoiType.TramStop, PoiType.SubwayStation] },
}

export const getPoiCategoryFromType = (poiType: PoiType): PoiCategory => {
  const strings = Object.keys(poiTypes) as PoiCategory[]
  const category = strings.find((category) => poiTypes[category].types.includes(poiType))
  if (!category) throw new Error(`Unexpected Point of interest type: ${poiType}`)
  return category
}

export const getPoiCategoryFromTypeString = (poiType: string): PoiCategory => {
  const strings = Object.keys(poiTypes) as PoiCategory[]
  const category = strings.find((category) => poiTypes[category].types.map((t) => t.toString()).includes(poiType))
  if (!category) throw new Error(`Unexpected Point of interest type: ${poiType}`)
  return category
}
